// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__1uoBP","tab":"TabNav_tab__3f-9b","link":"TabNav_link__3xPl0","selectedLink":"TabNav_selectedLink__2C8n_","disabled":"TabNav_disabled__25y8p"};